/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "cancelButtonLabel": [{
    "type": 0,
    "value": "Cancel"
  }],
  "closeButtonLabel": [{
    "type": 0,
    "value": "Close feedback"
  }],
  "defaultValidationErrorMessage": [{
    "type": 0,
    "value": "Share feedback to submit"
  }],
  "mobileCloseButtonLabel": [{
    "type": 0,
    "value": "Back"
  }],
  "mobileShareButtonLabel": [{
    "type": 0,
    "value": "Share feedback"
  }],
  "renderHeader": [{
    "type": 0,
    "value": "Share your feedback with us"
  }],
  "renderSuccess": [{
    "type": 0,
    "value": "Your feedback was submitted."
  }],
  "resubmitButtonLabel": [{
    "type": 0,
    "value": "Submit more feedback"
  }],
  "sentimentScaleForFeedbackFormLabel": [{
    "options": {
      "1": {
        "value": [{
          "type": 0,
          "value": "Very dissatisfied"
        }]
      },
      "2": {
        "value": [{
          "type": 0,
          "value": "Dissatisfied"
        }]
      },
      "3": {
        "value": [{
          "type": 0,
          "value": "Neither satisfied nor dissatisfied"
        }]
      },
      "4": {
        "value": [{
          "type": 0,
          "value": "Satisfied"
        }]
      },
      "5": {
        "value": [{
          "type": 0,
          "value": "Very satisfied"
        }]
      },
      "other": {
        "value": [{
          "type": 0,
          "value": "Other"
        }]
      }
    },
    "type": 5,
    "value": "level"
  }],
  "sentimentScaleForFeedbackFormNumericLabel": [{
    "type": 1,
    "value": "level"
  }, {
    "type": 0,
    "value": " out of "
  }, {
    "type": 1,
    "value": "max"
  }],
  "sentimentScaleForFeedbackFormNumericMaxLabel": [{
    "type": 0,
    "value": "Satisfied"
  }],
  "sentimentScaleForFeedbackFormNumericMinLabel": [{
    "type": 0,
    "value": "Not satisfied"
  }],
  "submitButtonLabel": [{
    "type": 0,
    "value": "Submit"
  }],
  "submittingButtonLabel": [{
    "type": 0,
    "value": "Submitting..."
  }],
  "textAreaForFeedbackFormCharactersRemaining": [{
    "offset": 0,
    "options": {
      "=0": {
        "value": [{
          "type": 1,
          "value": "charactersRemaining"
        }, {
          "type": 0,
          "value": " characters remaining."
        }]
      },
      "one": {
        "value": [{
          "type": 1,
          "value": "charactersRemaining"
        }, {
          "type": 0,
          "value": " character remaining."
        }]
      },
      "other": {
        "value": [{
          "type": 1,
          "value": "charactersRemaining"
        }, {
          "type": 0,
          "value": " characters remaining."
        }]
      }
    },
    "pluralType": "cardinal",
    "type": 6,
    "value": "charactersRemaining"
  }],
  "textAreaForFeedbackFormGetCharCountErrorMessage": [{
    "offset": 0,
    "options": {
      "=0": {
        "value": [{
          "type": 0,
          "value": "Delete "
        }, {
          "type": 1,
          "value": "charactersToBeDeleted"
        }, {
          "type": 0,
          "value": " characters."
        }]
      },
      "one": {
        "value": [{
          "type": 0,
          "value": "Delete "
        }, {
          "type": 1,
          "value": "charactersToBeDeleted"
        }, {
          "type": 0,
          "value": " character."
        }]
      },
      "other": {
        "value": [{
          "type": 0,
          "value": "Delete "
        }, {
          "type": 1,
          "value": "charactersToBeDeleted"
        }, {
          "type": 0,
          "value": " characters."
        }]
      }
    },
    "pluralType": "cardinal",
    "type": 6,
    "value": "charactersToBeDeleted"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var DefaultTranslationComp = Object.assign(TranslationProviderComponent, {
  translations
});

export { DefaultTranslationComp as D, translations as t };
//# sourceMappingURL=en-US-DU4VqPXy.js.map
